import styled from 'styled-components';

export const StyledClientIndicator = styled.div`
  position: relative;
  border-radius: ${(p) => p.theme.radii.pill};

  &:hover {
    box-shadow: 0px 0px 0px 2px ${(p) => p.theme.alias.bg},
      0px 0px 0px 4px ${(p) => p.color};
  }
`;
